import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { isProfileConnectionError } from '../lib/authProfileLoad'
import { getCurrentPlaceId } from '../lib/placeConfig'

/**
 * Redirects /app to /app/:defaultPlaceId/orders.
 * Use when user navigates to /app without a placeId (e.g. after login).
 * Waits for userProfile so we never redirect to another account's place (e.g. env default).
 */
export default function RedirectToDefaultPlace() {
  const auth = useAuth()

  if (!auth?.user) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    )
  }

  if (auth.loading || !auth.authReady) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    )
  }

  // Do not redirect until we have the current user's profile (defaultPlaceId).
  // Otherwise we might use getCurrentPlaceId() which could be env/default and leak to another place.
  if (!auth.userProfile?.defaultPlaceId) {
    const missingAccount = Boolean(auth.profileError) && !isProfileConnectionError(auth.profileError)
    return (
      <div style={{ padding: '2rem', textAlign: 'center', maxWidth: '28rem', margin: '0 auto' }}>
        <p>
          {auth.profileError ||
            'Could not load your account profile. Check your connection and try again.'}
        </p>
        <p style={{ marginTop: '1rem' }}>
          {missingAccount ? (
            <button type="button" onClick={() => void auth.logout()}>
              Sign out
            </button>
          ) : (
            <button type="button" onClick={() => window.location.reload()}>
              Retry
            </button>
          )}
        </p>
      </div>
    )
  }

  const defaultPlaceId = auth.userProfile.defaultPlaceId ?? getCurrentPlaceId()
  return <Navigate to={`/app/${defaultPlaceId}/orders`} replace />
}
